import React from 'react'
import { Box } from '@mui/material';
import { useState } from 'react';
import ServiceProviderListView from './ServiceProviderListView';


export default function ServiceProviderListPage() {
  const [sideSheet, setSideSheet] = useState<React.ReactNode |null>(null);

  return (
    <Box display='flex' flex={1} sx={{ height: "100%" }}>
      <Box display='flex' flex={1} flexDirection="column">
        <ServiceProviderListView setSideSheet={setSideSheet}/>
      </Box>
      {sideSheet}
    </Box>
  )
}